/*global swfobject, define, console */
define('all/player/playerinfo',['module', 'jquery', 'all/player/player', 'all/player/session', 'all/counter', 'all/navigation', 'all/dialog', 'all/flushcommunicationbar', 'all/slidingContentWrapper', 'all/jquery/jquery.cookie', 'all/scroller', 'all/template'], function(module, $, player, session, Counter, navigation, dialog, flushcommunicationbar, slidingContentWrapper) {
	'use strict';

	var playerinfo = {};

	var $playerbar;
	var $active;
	var $available;
	var $shopPromo;

	var regStatus = 0;

	var EVERY_SECOND = 1000;
	var formatter;

	function getFlooredValue(value, o) {
		var val = Math.round(value * Math.pow(10, o.precision)).toString();
		var wholePartLessThanOne = false;
		var wholePart = '0', wholeLength = 0, decimalPart = 0, decimalCheck = 0, decimalPadding = '';
		// handle 0.00
		while (val.length < o.precision + 1) {
			val += '0';
			wholePartLessThanOne = true;
			decimalCheck += 1;
		}

		if (!wholePartLessThanOne) {
			wholeLength = val.length - o.precision;
			wholePart = val.substring(0, wholeLength);
		}

		// split at thousandSeparator
		for (var i = 0; i < Math.floor((wholePart.length - (1 + i)) / 3); i++) {
			wholePart = wholePart.substring(0, wholePart.length - (4 * i + 3)) + o.thousandSeparator + wholePart.substring(wholePart.length - (4 * i + 3));
		}

		if (o.precision === 0) {
			return wholePart;
		}

		if (!wholePartLessThanOne) {
			decimalPart = val.substring(wholeLength, val.length);
		}
		else {
			if (decimalCheck <= 1) {
				decimalPart = val.substring(0, val.length - (decimalCheck));
			}
			else {
				for (i = 0; i < decimalCheck - 1; i++) {
					decimalPadding += '0';
				}
				decimalPart = decimalPadding + val.substring(0, val.length - decimalCheck);
			}
		}

		if (Number(decimalPart) === 0) {
			return wholePart;
		}

		return wholePart + o.decimalPoint + decimalPart;

	}

	function getFormatter(options) {
		var defaults = {
			thousandSeparator: '',
			decimalPoint: '.',
			symbol: '',
			currencyCode: '',
			precision: 2
		};

		options = $.extend(defaults, options);

		return {
			format: function(value, withCurrencyCode) {
				var flooredValue = getFlooredValue(value, options);
				var formattingWithCurrencyCode = (withCurrencyCode !== undefined) && withCurrencyCode;
				return (formattingWithCurrencyCode ? formatWithCurrencyCode(flooredValue, options) : formatWithCurrencySymbol(flooredValue, options));
			}
		};
	}

	function formatWithCurrencySymbol(flooredValue, options) {
		var symbol = options.symbol;
		var prefix = '';
		var suffix = '';
		if (symbol === '$' || symbol === '£' || symbol === '€') {
			prefix = symbol + ' ';
		} else {
			suffix = ' ' + symbol;
		}
		return prefix + flooredValue + suffix;
	}

	function formatWithCurrencyCode(flooredValue, options) {
		var suffix = ' ' + options.currencyCode;
		return flooredValue + suffix;
	}

	/*
	 * element is a jQuery element or a CSS identifier like '#clock', which will be updated
	 * if the element has an attribute data-offset set in HTML or by jQuery's .data(...)
	 * it will be used as UTC offset, in minutes.
	 *
	 * Examples:
	 *
	 * <div id="clock" data-offset="60"></div>
	 * $(function() {
	 *     new clock("#clock");
	 * });
	 *
	 * or:
	 *
	 * <div id="clock"></div>
	 *
	 * $(function() {
	 *      new clock("#clock");
	 * });
	 *
	 * $('#clock').data('offset', 60); // <-- will update on the fly next tick
	 *
	 */
	var clock = function(element) {

		var $element = $(element);

		function tick() {
			var now = new Date();

			var offset = Number($element.data('offset'));
			if (!isNaN(offset)) {
				var relativeOffsetInHours = (now.getTimezoneOffset() + offset) / 60;
				now.setUTCHours(now.getUTCHours() + relativeOffsetInHours);
			}

			var hours = now.getHours();
			var minutes = String(now.getMinutes());
			if (minutes.length !== 2) {
				minutes = '0' + minutes;
			}

			$element.html(hours + ':' + minutes);
		}

		window.setInterval(tick, EVERY_SECOND);
		tick();
	};

	function updateActiveBonuses(activeBonuses) {
		$active.scrollerStop();
		var $slideshow = $active.find('.slideshow');
		$slideshow.children('article').remove();

		var added = 0;
		for (var i = 0; i < activeBonuses.length; i++) {
			var bonus = activeBonuses[i];
			if (bonus.total <= 0 || bonus.percent >= 100) {
				continue;
			}

			var percentage = parseFloat(bonus.percent);
			if (Math.ceil(percentage) === 1 || (percentage > 0 && percentage < 5)) {
				percentage = 5;
			} else {
				percentage = Math.floor(percentage);
			}
			var bonusUpdate = {
				total: formatter.format(bonus.total),
				percent: 'width: ' + percentage + '%'
			};
			$slideshow.applyTemplate($.extend(bonus, bonusUpdate), {replace: false});
			added++;
		}

		if (added === 0) {
			if (playerinfo.info.hasAvailableBonuses === true) {
				showGetAvailableBonuses();
			} else {
				showShopForBonuses();
			}
			return;
		}

		$shopPromo.hide();
		$available.hide();
		$active.show();
		$slideshow.children('article').show();
		$active.scroller({direction: 'left', auto: false, continuous: false});

		$playerbar.find('.s16-info').show();
	}

	function showGetAvailableBonuses() {
		$playerbar.find('.s16-info').hide();
		$active.hide();
		$shopPromo.hide();
		$available.fadeIn('fast');
	}

	function showShopForBonuses() {
		$playerbar.find('.s16-info').hide();
		$active.hide();
		$available.hide();
		$shopPromo.fadeIn('fast');
	}

	// TODO: this is because a) IE bails out on access error and b) both sportsbook and mypages uses the id #bodyframe, see CO-8203
	function getBodyFrameSafely() {
		try {
			return $('#bodyframe').contents();
		} catch (e) {
			return $();
		}
	}

	function update(updateInfo) {
		console.log('update', updateInfo);

		if (updateInfo.username) {
			$playerbar.find('#username').text('(' + updateInfo.username + ')');
		}
		if (updateInfo.firstname) {
			$playerbar.find('#firstname').text(updateInfo.firstname + '!');
		}
		if(updateInfo.currencySymbol && updateInfo.locale) {
			setupCurrencyFormatter(updateInfo.currencySymbol, updateInfo.locale);
		}
		if (typeof updateInfo.totalBalance !== 'undefined') {
			$playerbar.find('#total-balance').text(formatter.format(updateInfo.totalBalance));
			$('.player-bar').find('.wallet p').text(formatter.format(updateInfo.totalBalance));
			getBodyFrameSafely().find('#totalBalance').text(formatter.format(updateInfo.totalBalance));
            $('.total-balance').text(updateInfo.totalBalance);
		}
		if (typeof updateInfo.lockedBalance !== 'undefined') {
			$playerbar.find('#locked-balance').text(formatter.format(updateInfo.lockedBalance));
            $('.box.withdraw').find('.balance .locked').text(formatter.format(updateInfo.lockedBalance, true));
		}
		if (typeof updateInfo.freeBalance !== 'undefined') {
			$playerbar.find('#unlocked-balance').text(formatter.format(updateInfo.freeBalance));
            $('.box.withdraw').find('.balance .unlocked').text(formatter.format(updateInfo.freeBalance, true));
			getBodyFrameSafely().find('#freeBalance').text(formatter.format(updateInfo.freeBalance));
		}
		if (typeof updateInfo.playerPoints !== 'undefined') {
            var initValue = 0;
            if ($('#cnt-player-bar').find('#player-points a').is(":visible")){
                initValue =  Number($playerbar.find('#player-points a').data('oldValue')) || 0;
            }

			$playerbar.find('#player-points a').data('value', updateInfo.playerPoints);
            var $playerPoints = $playerbar.find('#player-points a').text(initValue);
            new Counter($playerPoints, {thousandSeparator: ' '});

			$('.player-bar').find('.shop p').data('value', updateInfo.playerPoints);
            var $others = $('.player-bar').find('.shop p').text(initValue);
            new Counter($others, {thousandSeparator: ' '});
		}
		if (updateInfo.regStatus) {
			regStatus = updateInfo.regStatus;
			if (regStatus === 0) {
				playerinfo.info.email = updateInfo.email;
				playerinfo.info.countryId = updateInfo.countryId;
			}
		}
		if (updateInfo.activeBonuses) {
			$(function() {
				updateActiveBonuses(updateInfo.activeBonuses);
			});
		} else if (updateInfo.hasAvailableBonuses === true) {
			showGetAvailableBonuses();
		} else if (updateInfo.hasAvailableBonuses === false) {
			showShopForBonuses();
		}

		if (window.helpCenter) {
			window.helpCenter.set({
				contact: {
					firstName: updateInfo.firstname || '',
					lastName: updateInfo.lastname || '',
					username: updateInfo.username || '',
					email: updateInfo.email || '',
					phone: updateInfo.mobile || '',
					// hidden fields
					comeonSegment: updateInfo.valueSegmentCurrent || '',
					comeonHighestSegment: updateInfo.valueSegmentHighest || '',
					comeonSharedValue: updateInfo.allBrandsValueSegmentHighest || ''
				}
			});
		}

		playerinfo.info = $.extend(playerinfo.info, updateInfo);
	}

	function setupClock() {
		clock('#cnt-player-bar .links time');
	}

	function setupClickHandlers() {
		$('#cnt-player-bar-deposit,.deposit-btn a').on('click', slidingContentWrapper.showSlidingDeposit);
        $('#cnt-player-bar-withdraw').on('click', slidingContentWrapper.showSlidingWithdraw);

		$('#logout-button').on('click', player.logout);

		$playerbar.find('.toggle').css('cursor', 'pointer').on('click', function() {
			var $current = $(this);
			var visibility = 'visible';
			var $other = $current.prev('.toggle');

			if ($other.length === 0) {
				$other = $current.next('.toggle');
				visibility = 'hidden';
			}

			$playerbar.find('.confidential').each(function() {
				$(this).css('visibility', visibility);
			});

			$.cookie('confidential', $current.text(), { path: '/' });

			$current.hide();
			$other.show();

		});

		$active.find('article').css('cursor', 'pointer').on('click', function() {
			location.href = $(this).find('a').attr('href');
		});

		$.each([$available, $shopPromo], function() {
			$(this).css('cursor', 'pointer').on('click', function() {
				location.href = $(this).find('a').attr('href');
			});
		});

		$playerbar.find('#welcome,#firstname,#username').css('cursor', 'pointer').on('click', function() {
			location.href = $(this).parentsUntil('section').find('a').attr('href');
		});

		$playerbar.find('section:has(#player-points)').find('figure:has(.ui-icon)').css('cursor', 'pointer').on('click', function() {
			location.href = $(this).find('a').attr('href');
		});

		$playerbar.find('section:has(#player-points)').find('h1,p').css('cursor', 'pointer').on('click', function() {
			location.href = $playerbar.find('#player-points a').attr('href');
		});


        var $walletElements = $playerbar.find('.s40-wallet,h1.balance,#total-balance,.wallet');
        $.merge($walletElements, $('#casino-ingame').find('.wallet'));

        $walletElements.css('cursor', 'pointer').on('click', function() {
            slidingContentWrapper.showSlidingDeposit();
        });
    }

    function setupCurrencyFormatter(symbol, locale) {
        var options = {
            precision: 2,
            thousandSeparator: ' ',
            decimalPoint: '.',
            symbol: symbol || playerinfo.info.currencySymbol,
			currencyCode: playerinfo.info.currencyCode
        };

        // TODO: clean up, better lookup
        var countriesUsingComaAsDecimalPoint = ['SE', 'FI', 'NO', 'RU', 'NL', 'PL', 'CL', 'RS'];
        var country = ((locale || playerinfo.info.locale).split(/[\-_]/)[1]).toUpperCase();
        if ($.inArray( country, countriesUsingComaAsDecimalPoint ) > -1) {
            options.decimalPoint = ',';
        }

        formatter = getFormatter(options);
    }

    function setupCounters() {
        var $playerPoints = $playerbar.find('#player-points a').text('0');
        $playerbar.find('#player-points a').data('oldValue', 0);
        new Counter($playerPoints, {thousandSeparator: ' '});
        var $others = $('.player-bar').find('.shop p').text('0');
        new Counter($others, {thousandSeparator: ' '});
    }

    function refreshSession(){
        $.ajax({url: '/pp?flow=Ping'});
    }

    $(function(){
        playerinfo.initialized = false;

        // TODO: the dance between this, update() and login.js is messy, clean up the structure
        playerinfo.init = function(info) {
            if (window.top !== window.self) {
                return;
            }

            if (playerinfo.initialized) {
                playerinfo.update(info);
                return;
            }

            playerinfo.initialized = true;
            playerinfo.info = info;

            $playerbar = $('#cnt-player-bar');
            $active = $playerbar.find('#bonus-active');
            $available = $playerbar.find('#bonus-notactive');
            $shopPromo = $playerbar.find('#shop-promo');

            setupClickHandlers();
            setupClock();
            setupCurrencyFormatter();
            update(playerinfo.info);

            $playerbar.find('.toggle:contains(' + $.cookie('confidential') + ')').trigger('click');

            setupCounters();
            flushcommunicationbar.flushCommunicationBar();


        };

        playerinfo.update = update;
        playerinfo.getFormatter = getFormatter;
        playerinfo.openDeposit = slidingContentWrapper.showSlidingDeposit;

        playerinfo.onFlashInit = function() {
            return playerinfo.info;
        };


        var configuration = module.config();
        playerinfo.info = configuration.info;

        if (!playerinfo.info.needsLogin) {
            if (playerinfo.info.error) {
                session.logout();
            } else {
                playerinfo.init(playerinfo.info);
            }
        }

        window.playerinfo = playerinfo;

		require(['websocket'], function (websocketEvent) {
			websocketEvent.on('player.update', function (e, data) {
				update(data);
			});

			websocketEvent.on('player.message', function (e, data) {
				showPushInfoMessage(data.panelHeader, data.header, data.message);
			});

			websocketEvent.on('player.logout', function (e, data) {
				player.pushedLogout("", data.header, data.message, data.webSessionIdToKeep);
			});

			websocketEvent.on('session.refresh', function (e, data) {
				//call BL to refresh tomcat session
                refreshSession();
			});
		});

    });

    return playerinfo;
});

